import { useMutation } from "@tanstack/react-query";
import { useOptionalReploAgent } from "@v2/contexts/ReploAgentContext";
import { ReploError } from "schemas/errors";

abstract class ResetProjectError extends ReploError {}
class NoAgentConnectionError extends ResetProjectError {}
class UnknownResetProjectError extends ResetProjectError {}

export function useResetProject() {
  const agentContext = useOptionalReploAgent();

  const mutation = useMutation({
    mutationFn: async () => {
      if (!agentContext) {
        throw new NoAgentConnectionError({
          message: "Agent connection not available",
        });
      }
      const result = await agentContext.actions.resetProject();
      if (!result.ok) {
        throw new UnknownResetProjectError({ message: result.message });
      }
      return result;
    },
  });

  return {
    resetProject: mutation.mutateAsync,
    isResettingProject: mutation.isPending,
    resetProjectError: mutation.error,
  };
}
